import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClientService, TENANT_API } from '@pharvio/core/shared';
import { AssistantDataService } from './assistant-data.service';
import {
  AssistantResponse,
  Conversation,
  SendMessagePayload
} from '../models/assistant.model';

@Injectable()
export class HttpAssistantDataService extends AssistantDataService {
  private readonly api = inject(ApiClientService);

  getConversations(): Observable<Conversation[]> {
    return this.api.get<Conversation[]>(TENANT_API.ASSISTANT.CONVERSATIONS);
  }

  getConversation(id: string): Observable<Conversation> {
    return this.api.get<Conversation>(TENANT_API.ASSISTANT.CONVERSATION_BY_ID(id));
  }

  createConversation(): Observable<Conversation> {
    return this.api.post<Conversation>(TENANT_API.ASSISTANT.CONVERSATIONS, {});
  }

  sendMessage(payload: SendMessagePayload): Observable<AssistantResponse> {
    return this.api.post<AssistantResponse>(TENANT_API.ASSISTANT.CHAT, payload);
  }

  deleteConversation(id: string): Observable<void> {
    return this.api.delete<void>(TENANT_API.ASSISTANT.CONVERSATION_BY_ID(id));
  }
}
